// import positionsJson from "../../../static/file/positions.json";
// import positionsJson from "/file/positions.json" assert {type: 'json'}
// $.getJSON('/file/positions.json', (positionsJson) => {
// 	console.log(positionsJson)
// })
// const  positionsJson = fs

// var xhr = new XMLHttpRequest();
// xhr.onreadystatechange = function () {
// 	if (xhr.readyState === 4 && xhr.status === 200) {
// 		var jsonData = JSON.parse(xhr.responseText);
// 		console.log(jsonData); // JSONデータを使用する処理を行う
// 	}
// };
// xhr.open("GET", "/file/positions.json", true);
// xhr.send();
// console.log(positionsJson)

import { Loader } from '@googlemaps/js-api-loader'
import MicroModal from 'micromodal'

export class GoogleMap {
	loader = new Loader({
		apiKey: 'AIzaSyDI3ip7vuyvJLFPzk3huqqfF4TBKOXcVYo',
		version: 'weekly',
	})
	// loader;
	positions
	map
	// markers;
	// infoWindows;
	markersAndInfoWindowsObject = []
	// $dialog = $(".dialog");
	$buttons = $('.btn--map__category')
	styles = [
		{
			stylers: [{ hue: '' }, { saturation: '-30' }, { lightness: '5' }, { visibility: 'undefined' }, { invert_lightness: false }],
		},
		{
			elementType: 'geometry',
			stylers: [{ color: '' }, { visibility: 'undefined' }],
		},
		{
			elementType: 'labels.icon',
			stylers: [{ hue: '' }, { saturation: '0' }, { lightness: '0' }, { visibility: 'off' }],
		},
		{
			elementType: 'labels.text.fill',
			stylers: [{ color: '' }, { visibility: 'on' }],
		},
		{
			elementType: 'labels.text.stroke',
			stylers: [{ color: '' }, { visibility: 'on' }],
		},
		{
			featureType: 'landscape',
			elementType: 'geometry',
			stylers: [{ color: '' }, { visibility: 'on' }],
		},
		{
			featureType: 'poi.business',
			elementType: 'geometry',
			stylers: [{ color: '' }, { visibility: 'on' }],
		},
		{
			featureType: 'poi.park',
			elementType: 'geometry',
			stylers: [{ color: '' }, { visibility: 'on' }],
		},
		{
			featureType: 'road',
			elementType: 'geometry',
			stylers: [{ color: '' }, { visibility: 'on' }],
		},
		{
			featureType: 'transit',
			elementType: 'geometry',
			stylers: [{ color: '' }, { visibility: 'on' }],
		},
		{
			featureType: 'transit.station',
			elementType: 'labels.text.fill',
			stylers: [{ color: '' }, { visibility: 'on' }],
		},
		{
			featureType: 'water',
			elementType: 'geometry',
			stylers: [{ color: '' }, { visibility: 'on' }],
		},
	]

	constructor() {
		this.init()
	}

	init() {
		if (document.getElementById('google-map')) {
			;(async () => {
				try {
					const res = await fetch('/file/positions.json')
					// const res = await fetch("/wp-content/themes/t-port/file/positions.json");
					const result = await res.json()
					this.positions = await result

					await this.loader.load()
					this.map = new google.maps.Map(document.getElementById('google-map'), {
						center: new google.maps.LatLng(this.positions.center.lat, this.positions.center.lang),
						zoom: 12,
						streetViewControl: false,
						mapTypeControl: false,
						fullscreenControl: false,
						styles: this.styles,
					})
					this.createMarkersAndInfoWindows()

					this.$buttons.each((index, button) => {
						const $button = $(button)

						$button.on('click', () => {
							if ($button.hasClass('all')) {
								this.$buttons.removeClass('current')
								$button.addClass('current')
								this.markersAndInfoWindowsObject.forEach((obj) => {
									obj.marker.setMap(this.map)
								})
							} else {
								this.$buttons.each((index, btn) => {
									if ($(btn).hasClass('all') && $(btn).hasClass('current')) {
										this.$buttons.removeClass('current')
									}
								})
								if ($button.hasClass('current')) {
									$button.removeClass('current')
									this.markersAndInfoWindowsObject.forEach((obj) => {
										if ($button.hasClass(obj.marker.getTitle())) {
											obj.marker.setMap(null)
										}
									})
								} else {
									$button.toggleClass('current')
									this.markersAndInfoWindowsObject.forEach((obj) => {
										obj.marker.setMap(null)
										this.keepActiveMarker(obj)
										if ($button.hasClass(obj.marker.getTitle())) {
											obj.marker.setMap(this.map)
										}
									})
								}
							}
						})
					})
				} catch (error) {
					throw new Error(`Google Maps APIの読み込み中にエラーが発生しました。${error}`)
				}
			})()
		}
	}

	createMarkersAndInfoWindows() {
		this.positions.facilitys.forEach((position, index) => {
			const marker = new google.maps.Marker({
				position: new google.maps.LatLng(position.lat, position.lang),
				// icon: `/wp-content/themes/t-port/img/icons/map-icon/marker-${position.category[0]}.svg`,
				icon: `/img/icons/map-icon/marker-${position.category[0]}.svg`,
				map: this.map,
				title: position.category[0],
				zIndex:
					position.category[0] === 'church'
						? 40
						: position.category[0] === 'school-lunch'
						? 30
						: position.category[0] === 'clinic'
						? 20
						: position.category[0] === 'sport'
						? 20
						: position.category[0] === 'house'
						? 30
						: position.category[0] === 'hotel'
						? 10
						: position.category[0] === 'rest'
						? 0
						: 1,
			})
			const infoWindow = new google.maps.InfoWindow({
				content: this.createInfoWindow(position.name, position.category),
			})

			marker.addListener('click', () => {
				this.markersAndInfoWindowsObject.forEach(({ infoWindow }) => {
					infoWindow.close()
				})
				infoWindow.open({
					anchor: marker,
					map: this.map,
				})
			})
			infoWindow.addListener('domready', () => {
				// $(".modal-open-btn").on("click", this.handleDialogOpen(position));
				$('.modal-open-btn').on('click', function () {
					const $dialog = $('.dialog')

					$dialog.replaceWith(`
					<div class="dialog block" role="dialog" aria-modal="true" aria-labelledby="modal-title"><button class="close-btn btn--primary" aria-label="Close modal" data-micromodal-close type="button"><span class="text">閉じる</span><span class="icon"></span></button>
						<h2 id="modal-title">
							<span class="icon"></span>
							<span class="text">${position.name}</span>
						</h2>
						<div class="modal-body">
							<div class="image-container pc ">
							${
								position.imgUrls.length === 0
									? ''
									: position.imgUrls
											.map(
												(url) =>
													`
									<img class="image" src="${url}" alt="${position.name}">

								`,
											)
											.join('')
							}
					</div>
							<div class="modal__main-container">
								<div class="info-container">
									${position.infos.map((info) => `<p>${info}</p>`).join('')}
								</div>
								<div class="content">
									${position.content ? position.content : ''}
								</div>
								
								${
									position.gurunaviUrl
										? `
								<div class="gurunavi">
								<a href="${position.gurunaviUrl}">
									<img src="/img/map/gurunavi.jpg" alt="グルナビへ">
										</a>
								</div>
								`
										: ''
								}

								<div class="image-container sp">
									${
										position.imgUrls.length === 0
											? ''
											: position.imgUrls
													.map(
														(url) =>
															`
											<img class="image" src="${url}" alt="${position.name}">
										`,
													)
													.join('')
									}
							</div>
						</div>
					</div>
				`)

					MicroModal.show('map-modal')
				})
			})
			this.markersAndInfoWindowsObject.push({ marker, infoWindow })
		})
	}

	createInfoWindow(title, categorys) {
		const icons = categorys.map((category) => `<i class="icon ${category}"></i>`).join('')

		const markerContent = `
		<div class="marker-content">
			<p class="title">${title}</p>
			<div class="icon-container">${icons}</div> 
			<button class="modal-open-btn" data-micromodal-trigger="map-modal" role="button">詳しく見る</button>
		</div>`

		return markerContent
	}

	keepActiveMarker(obj) {
		this.$buttons.each((index, button) => {
			const hasActive = $(button).hasClass('current')
			if ($(button).hasClass(obj.marker.getTitle()) && hasActive) {
				obj.marker.setMap(this.map)
			}
		})
	}
}
// handleDialogOpen(position) {
// 	const $dialog = $(".dialog");

// 	$dialog.replaceWith(`
// 		<div class="dialog block" role="dialog" aria-modal="true" aria-labelledby="modal-title"><button class="btn btn--primary" aria-label="Close modal" data-micromodal-close type="button"><span class="text">閉じる</span><span class="icon"></span></button>
// 			<h2 id="modal-title"> <span class="icon"> </span><span class="text">${position.name}</span></h2>
// 			<div class="info-container">
// 				<p class="address">住所：港区海岸3-9-40</p>
// 				<p class="tel">電話：03(3456)1566</p>
// 				<p class="fax">FAX：03 (3769)3055</p>
// 			</div>
// 			<div class="content">
// 				<p>☆日替わり弁当の他、仕出し弁当やオードブル等のご注文も承っております☆</p>
// 			</div>
// 			<div class="image-box"> <img class="image" src="/img/map/school-lunch1-1.jpeg"></div>
// 			<div class="image-box"> <img class="image" src="/img/map/school-lunch2-1.jpeg"></div>
// 		</div>
// 	`);

// 	MicroModal.show("map-modal");
// }
